export default __webpack_public_path__ + "static/media/up-icon.60882dd3.svg";